<template>
  <v-app>
    <v-main class="main-container">
      <div class="main-and-footer-container">
        <v-alert
          class="ma-3 white--text alert"
          dismissible
          :color="alert.color"
          v-model="show"
        >
          {{alert.text}}
        </v-alert>
        <router-view/>
        <TheFooter />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import TheFooter from '@/components/TheFooter.vue';

export default {
  name: 'App',
  components: { TheFooter },
  computed: {
    ...mapState(['alert']),
    ...mapFields(['alert.show']),
  },
};
</script>

<style lang="scss" scoped>
.main-and-footer-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.alert {
  width: calc(100% - 24px);
  position: absolute;
}
</style>
